<template>
  <path
    d="M15.88 9.2903L12 13.1703L8.12001 9.2903C7.73001 8.9003 7.10001 8.9003 6.71001 9.2903C6.32001 9.6803 6.32001 10.3103 6.71001 10.7003L11.3 15.2903C11.69 15.6803 12.32 15.6803 12.71 15.2903L17.3 10.7003C17.69 10.3103 17.69 9.6803 17.3 9.2903C16.91 8.9103 16.27 8.9003 15.88 9.2903Z"
  />
</template>
